document.addEventListener('DOMContentLoaded', function () {
  const galleries = document.querySelectorAll('.custom-product-gallery');

  galleries.forEach((gallery) => {
    const thumbs = gallery.querySelectorAll('.custom-product-gallery__thumb');
    const slides = gallery.querySelectorAll('.custom-product-gallery__slide');

    if (!thumbs.length || !slides.length) return;

    const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

    const setActive = (index) => {
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
      });

      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = parseInt(thumb.dataset.mediaIndex, 10);
        const target = gallery.querySelector(
          `.custom-product-gallery__slide[data-media-index="${index}"]`
        );

        if (!target) return;

        if (isMobile()) {
          setActive(index);
        } else {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
          setActive(index);
        }
      });
    });

    let observer = null;

    const initDesktopObserver = () => {
      if (observer) observer.disconnect();

      if (isMobile()) return;

      observer = new IntersectionObserver(
        (entries) => {
          const visibleEntry = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (visibleEntry) {
            const index = parseInt(visibleEntry.target.dataset.mediaIndex, 10);
            setActive(index);
          }
        },
        {
          root: null,
          threshold: [0.3, 0.5, 0.7]
        }
      );

      slides.forEach((slide) => observer.observe(slide));
    };

    setActive(0);
    initDesktopObserver();

    window.addEventListener('resize', () => {
      initDesktopObserver();
      if (isMobile()) {
        const activeThumb = gallery.querySelector('.custom-product-gallery__thumb.is-active');
        const activeIndex = activeThumb ? parseInt(activeThumb.dataset.mediaIndex, 10) : 0;
        setActive(activeIndex);
      }
    });
  });
});